var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-571c794b-67ce-4e1a-acdd-4cd96778db0a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-bb94dcaf-1e19-4f02-97dc-de98b16ff22f",
    d: "M1032.9,487.75H155.12L491.68,125.28c17.71-19.09,16.61-48.9-2.44-66.56-19.04-17.71-48.9-16.65-66.56,2.44L12.6,502.79c-2.05,2.2-3.07,4.89-4.61,7.35-1.51,2.37-3.36,4.43-4.43,7.06-2.29,5.62-3.52,11.55-3.54,17.53,0,.05-.02.08-.02.13,0,.75.39,1.37.43,2.11.24,5.21,1.12,10.36,3.08,15.28,1.08,2.71,2.92,4.86,4.46,7.29,1.46,2.32,2.36,4.88,4.27,6.97l410.08,451.94c9.29,10.26,22.08,15.46,34.87,15.46,11.32,0,22.63-4.05,31.65-12.24,19.27-17.48,20.7-47.24,3.22-66.51l-338.6-373.19h879.45c26.04,0,47.1-21.07,47.1-47.1s-21.07-47.1-47.1-47.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.b59cca817711292cccbf2332416b9cbf.svg";
export { ForwardRef as ReactComponent };